export default __webpack_public_path__ + "static/media/PAFI_Annual Report 2024.59950fb3.pdf";